export const /** Workflow Action Types */ ACTION_TYPES = {
    INPUT: 'Input',
    TOOL: 'Tool',
    PROMPT: 'Prompt',
};
